export default __webpack_public_path__ + "static/media/elza-zuid.63780ba9.jpg";